export const webDevelopment = {
  is: {
    title: "Vefsíðugerð",
    subtitle: "Sérsniðnar veflausnir fyrir þitt fyrirtæki",
    description: "Við sérhæfum okkur í þróun á opnum veflausnum og sérsniðnum kerfum sem skila raunverulegum árangri fyrir þitt fyrirtæki.",
    featuresTitle: "Allt sem þú þarft í veflausn",
    featuresDescription: "Við bjóðum upp á heildarlausnir í vefþróun",
    features: {
      responsive: {
        title: "Snjalltækjavæn hönnun",
        description: "Fullkomin aðlögun að öllum skjástærðum"
      },
      seo: {
        title: "SEO vænt",
        description: "Innbyggð leitarvélabestun fyrir betri sýnileika"
      },
      fast: {
        title: "Hraðvirkt",
        description: "Hámarks afköst og hröð svörun"
      },
      secure: {
        title: "Öruggt",
        description: "Hámarks öryggi og reglulegar uppfærslur"
      },
      custom: {
        title: "Sérsniðin virkni",
        description: "Sérsniðnar lausnir fyrir þínar þarfir"
      },
      support: {
        title: "Fagleg þjónusta",
        description: "Stöðug aðstoð og ráðgjöf"
      }
    },
    platforms: {
      title: "Tæknilausnir og kerfi",
      description: "Við vinnum með nýjustu tækni og bestu lausnum",
      openSolutions: {
        title: "Opnar veflausnir",
        description: "Sérsniðnar veflausnir með opnum kerfum"
      },
      headlessCms: {
        title: "Headless CMS",
        description: "Sveigjanleg efnisstjórnun"
      },
      databases: {
        title: "Gagnagrunnar",
        description: "Öflug gagnagrunnskerfi"
      }
    },
    cta: {
      title: "Tilbúin að hefja þitt verkefni?",
      description: "Láttu okkur hjálpa þér að byggja upp öfluga veflausn sem uppfyllir þínar þarfir",
      button: "Fá tilboð í vefsíðu"
    }
  },
  en: {
    title: "Web Development",
    subtitle: "Custom web solutions for your business",
    description: "We specialize in developing open web solutions and custom systems that deliver real results for your business.",
    featuresTitle: "Everything you need in a web solution",
    featuresDescription: "We offer comprehensive solutions in web development",
    features: {
      responsive: {
        title: "Responsive Design",
        description: "Perfect adaptation to all screen sizes"
      },
      seo: {
        title: "SEO Friendly",
        description: "Built-in search engine optimization for better visibility"
      },
      fast: {
        title: "Fast Loading",
        description: "Maximum performance and quick response"
      },
      secure: {
        title: "Secure",
        description: "Maximum security and regular updates"
      },
      custom: {
        title: "Custom Functionality",
        description: "Custom solutions for your needs"
      },
      support: {
        title: "Professional Service",
        description: "Continuous assistance and guidance"
      }
    },
    platforms: {
      title: "Technical Solutions and Systems",
      description: "We work with the latest technology and best solutions",
      openSolutions: {
        title: "Open Web Solutions",
        description: "Custom web solutions with open systems"
      },
      headlessCms: {
        title: "Headless CMS",
        description: "Flexible content management"
      },
      databases: {
        title: "Databases",
        description: "Powerful database systems"
      }
    },
    cta: {
      title: "Ready to start your project?",
      description: "Let us help you build a powerful web solution that meets your needs",
      button: "Get a website quote"
    }
  },
  es: {
    title: "Desarrollo Web",
    subtitle: "Soluciones web personalizadas para su empresa",
    description: "Nos especializamos en desarrollar soluciones web abiertas y sistemas personalizados que brindan resultados reales para su empresa.",
    featuresTitle: "Todo lo que necesita en una solución web",
    featuresDescription: "Ofrecemos soluciones integrales en desarrollo web",
    features: {
      responsive: {
        title: "Diseño Responsivo",
        description: "Adaptación perfecta a todos los tamaños de pantalla"
      },
      seo: {
        title: "Optimizado para SEO",
        description: "Optimización de motores de búsqueda integrada para mejor visibilidad"
      },
      fast: {
        title: "Carga Rápida",
        description: "Máximo rendimiento y respuesta rápida"
      },
      secure: {
        title: "Seguro",
        description: "Máxima seguridad y actualizaciones regulares"
      },
      custom: {
        title: "Funcionalidad Personalizada",
        description: "Soluciones personalizadas para sus necesidades"
      },
      support: {
        title: "Servicio Profesional",
        description: "Asistencia y orientación continua"
      }
    },
    platforms: {
      title: "Soluciones Técnicas y Sistemas",
      description: "Trabajamos con la última tecnología y las mejores soluciones",
      openSolutions: {
        title: "Soluciones Web Abiertas",
        description: "Soluciones web personalizadas con sistemas abiertos"
      },
      headlessCms: {
        title: "CMS Headless",
        description: "Gestión de contenido flexible"
      },
      databases: {
        title: "Bases de Datos",
        description: "Potentes sistemas de bases de datos"
      }
    },
    cta: {
      title: "¿Listo para comenzar su proyecto?",
      description: "Permítanos ayudarle a construir una potente solución web que satisfaga sus necesidades",
      button: "Obtener presupuesto web"
    }
  },
  da: {
    title: "Webudvikling",
    subtitle: "Skræddersyede webløsninger til din virksomhed",
    description: "Vi specialiserer os i at udvikle åbne webløsninger og skræddersyede systemer, der leverer reelle resultater for din virksomhed.",
    featuresTitle: "Alt hvad du behøver i en webløsning",
    featuresDescription: "Vi tilbyder omfattende løsninger inden for webudvikling",
    features: {
      responsive: {
        title: "Responsivt Design",
        description: "Perfekt tilpasning til alle skærmstørrelser"
      },
      seo: {
        title: "SEO-venlig",
        description: "Indbygget søgemaskineoptimering for bedre synlighed"
      },
      fast: {
        title: "Hurtig Indlæsning",
        description: "Maksimal ydeevne og hurtig respons"
      },
      secure: {
        title: "Sikker",
        description: "Maksimal sikkerhed og regelmæssige opdateringer"
      },
      custom: {
        title: "Tilpasset Funktionalitet",
        description: "Skræddersyede løsninger til dine behov"
      },
      support: {
        title: "Professionel Service",
        description: "Kontinuerlig assistance og vejledning"
      }
    },
    platforms: {
      title: "Tekniske Løsninger og Systemer",
      description: "Vi arbejder med den nyeste teknologi og de bedste løsninger",
      openSolutions: {
        title: "Åbne Webløsninger",
        description: "Skræddersyede webløsninger med åbne systemer"
      },
      headlessCms: {
        title: "Headless CMS",
        description: "Fleksibel indholdsstyring"
      },
      databases: {
        title: "Databaser",
        description: "Kraftfulde databasesystemer"
      }
    },
    cta: {
      title: "Klar til at starte dit projekt?",
      description: "Lad os hjælpe dig med at opbygge en kraftfuld webløsning, der opfylder dine behov",
      button: "Få et websitetilbud"
    }
  }
};